/**
 * Labels and formatting for notification rows (header dropdown, profile grid).
 */

export {
  getNotificationTypeLabel,
  getNotificationTriggerHint,
  resolveNotificationDisplay,
  notificationMatchesSearchQuery,
} from '@/shared/notifications/notificationRegistry';

export { buildNotificationContext } from '@/shared/notifications/buildNotificationContext';

export function formatNotificationDate(dateString) {
  if (!dateString) return '—';
  try {
    const date = new Date(dateString);
    return new Intl.DateTimeFormat('sr-RS', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    }).format(date);
  } catch {
    return dateString;
  }
}

/** Краћи приказ за хедер дропдовн (компактни редови). */
export function formatNotificationDateCompact(dateString) {
  if (!dateString) return '—';
  try {
    const date = new Date(dateString);
    return new Intl.DateTimeFormat('sr-RS', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    }).format(date);
  } catch {
    return dateString;
  }
}
